import React from "react";
import {bool, func, string} from "prop-types";
import {
    Modal,
    ModalContent,
    Text
} from '@rebrandly/styleguide'
import './ShareModal.css'
import FacebookShareButton from "./FacebookShareButton";
import TwitterShareButton from "./TwitterShareButton";
import LinkedinShareButton from "./LinkedinShareButton";
import EmailShareButton from "./EmailShareButton";

const iconsShare1Row  = [
    {
        id: 1,
        Component: FacebookShareButton,
        buttonProps: {
            icon: { name: "ic-social-facebook-square", position: "left" },
            size: 'lg',
            className: 'Button--block ShareModal__button',
            children: 'Facebook'
        }
    },
    {
        id: 2,
        Component: TwitterShareButton,
        buttonProps: {
            icon: { name: "ic-social-twitter-filled", position: "left" },
            size: 'lg',
            className: 'Button--block ShareModal__button',
            children: 'X'
        }
    }
]
const iconsShare2Row = [
    {
        id: 3,
        Component: LinkedinShareButton,
        buttonProps: {
            icon: { name: "ic-social-linkedin", position: "left" },
            size: 'lg',
            className: 'Button--block ShareModal__button',
            children: 'LinkedIn'
        }
    },
    {
        id: 4,
        label: 'Email',
        name: 'ic-mail',
        Component: EmailShareButton,
        buttonProps: {
            icon: { name: "ic-mail", position: "left" },
            size: 'lg',
            className: 'Button--block ShareModal__button',
            children: 'Email'
        }
    }
]

const ShareModal = ({ isOpen, onClose, shortUrl}) => (
    <Modal isOpen={isOpen} onClose={onClose} size="md" showClose>
        <ModalContent>
            <Text className='text-center p-b-32' size='x-large'>Share your short link</Text>
            <div className="flex gap-8">
                {iconsShare1Row.map((item, index) => {
                    const { Component, buttonProps = {} } = item;

                    return (
                        <Component
                            key={index}
                            buttonProps={buttonProps}
                            url={shortUrl}
                        />
                    );
                })}
            </div>
            <div className="flex gap-8 m-t-16">
                {iconsShare2Row.map((item, index) => {
                    const { Component, buttonProps = {} } = item;

                    return (
                        <Component
                            key={index}
                            buttonProps={buttonProps}
                            url={shortUrl}
                        />
                    );
                })}
            </div>

        </ModalContent>
    </Modal>
)

ShareModal.propTypes = {
    isOpen: bool,
    onClose: func,
    shortUrl: string,
}

export default ShareModal;